import Hero from './Hero.js'

function HeroBasic({ title, subtitle }) {
    return (
        <Hero>
            <h1>{title}</h1>
            <p>{subtitle}</p>
        </Hero>
    )
}

export default HeroBasic